import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ActionButton } from 'core/components/action-button';
import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import closeIcon from 'core/assets/svg/x.svg';
import useStyles from './offer-branch-plus-modal.styles';
import { brandConstants } from 'brand-config';

const OfferBranchPlusModal = ({ open, onClose, submitBranchPlus }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} classes={{ paper: classes.container }}>
      <ActionButton type="edit" size="big" icon={closeIcon} className={classes.closeButton} onClick={onClose} />
      <DialogTitle>
        <Label className={classes.title}>This offer isn't currently eligible for BIX.</Label>
      </DialogTitle>
      <DialogContent>
        <Label className={classes.subtitle}>
          Are you interested in seeing {brandConstants.SHORT_NAME} Plus offers instead?
        </Label>
        <div className={classes.buttonRow}>
          <Button className={classes.returnButton} variant="contained" color="secondary" onClick={onClose}>
            <Label>No, go back</Label>
          </Button>
          <Button className={classes.submitButton} variant="contained" color="primary" onClick={submitBranchPlus}>
            <Label>Yes, submit for {brandConstants.SHORT_NAME} Plus only offers</Label>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

OfferBranchPlusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  submitBranchPlus: PropTypes.func.isRequired
};
export default OfferBranchPlusModal;
